

function CusButton(props) {

    const { isLoading = false, type = 'primary', title = '', handleClick, buttonType = "button" } = props

    return (
        <button
            className={`commonButtonPri ${type === 'secondary' ? "commonButtonSec" : ''}`}
            disabled={isLoading ? true : false}
            onClick={handleClick}
            type={buttonType}
        >
            {" "}
            {isLoading ? (
                <div
                    class="spinner-border text-light"
                    role="status"
                    style={{
                        width: "1.2rem",
                        height: "1.2rem",
                        position: "static",
                        marginLeft: "40%",
                    }}
                ></div>
            ) : title}
        </button>
    )

}

export default CusButton

